module.exports = __webpack_public_path__ + "static/img/stay-option-icon-cafe.a9bab312.svg";